import { MessageCircle } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function Customization() {
  const { settings, homepage, whatsappLink } = useSettings();
  const c = homepage.customization || {};
  return (
    <main className="page" data-testid="customization-page">
      <div className="page-head">
        <span className="eyebrow">Bespoke</span>
        <h1>
          {c.heading?.split(" ")[0] || "Made"} <em>{c.heading?.split(" ").slice(1).join(" ") || "for you."}</em>
        </h1>
      </div>
      <div style={{ maxWidth: 720 }}>
        <p style={{ color: "var(--muted)", fontSize: 16, lineHeight: 1.85, marginBottom: 40 }}>{c.body}</p>
        <div style={{ borderTop: "1px solid var(--line)", paddingTop: 24 }}>
          <span className="eyebrow" style={{ display: "block", marginBottom: 12 }}>Send us your ideas</span>
          <a
            href={whatsappLink("Hi Lalita Soujanya, I'd like to enquire about customization.")}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary"
            data-testid="customization-whatsapp-cta"
          >
            {settings.whatsapp_button_label || "Order contact now"} — {settings.whatsapp_number} <MessageCircle size={16} />
          </a>
        </div>
      </div>
    </main>
  );
}
